module.exports = __webpack_public_path__ + "static/media/master-card-web-icon.e57a7169.svg";